import React from "react";
import { MdVerified, MdLocalShipping, MdInventory } from "react-icons/md";
import styles from "./ValueProps.module.css";

export default function ValueProps() {
  const props = [
    {
      icon: <MdVerified size={32} />,
      title: "Expert Fitment",
      description: "Certified technicians for precision mounting.",
    },
    {
      icon: <MdLocalShipping size={32} />,
      title: "Fast Delivery",
      description: "Doorstep delivery within 24-48 hours.",
    },
    {
      icon: <MdInventory size={32} />,
      title: "Genuine Parts",
      description: "100% authentic, manufacturer-sealed inventory.",
    },
  ];

  return (
    // <section className={styles.valuePropsSection}>
    //   <div className={styles.container}>
    //     {props.map((prop, idx) => (
    //       <div key={idx} className={styles.propCard}>
    //         <div className={styles.iconCircle}>
    //           {prop.icon}
    //         </div>
    //         <div className={styles.textGroup}>
    //           <h3 className={styles.title}>{prop.title}</h3>
    //           <p className={styles.description}>{prop.description}</p>
    //         </div>
    //       </div>
    //     ))}
    //   </div>
    // </section>
    <></>
  );
}
